var _excluded = ["content", "trigger", "placement", "showing", "appearance", "children", "layer", "maxWidth", "isRelativeToChild"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ClassNames } from '@emotion/core';
import BaseTooltip from 'rc-tooltip';
import * as styles from './tooltip.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Tooltip = _ref => {
  var content = _ref.content,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? ['hover'] : _ref$trigger,
    placement = _ref.placement,
    showing = _ref.showing,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'blue' : _ref$appearance,
    children = _ref.children,
    _ref$layer = _ref.layer,
    layer = _ref$layer === void 0 ? 'layerTooltip' : _ref$layer,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 260 : _ref$maxWidth,
    _ref$isRelativeToChil = _ref.isRelativeToChild,
    isRelativeToChild = _ref$isRelativeToChil === void 0 ? false : _ref$isRelativeToChil,
    props = _objectWithoutProperties(_ref, _excluded);
  var isWhiteDesign = appearance === 'white';
  var getContent = () => {
    if (/*#__PURE__*/React.isValidElement(content)) {
      return content;
    }
    return /*#__PURE__*/React.createElement('span', [], content);
  };
  var extraProps = typeof showing === 'undefined' ? props : _objectSpread(_objectSpread({}, props), {}, {
    visible: showing
  });
  var renderChildren = isRelativeToChild ? ___EmotionJSX("div", {
    css: styles.relativeParent
  }, children) : children;
  return ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return ___EmotionJSX(BaseTooltip, _extends({
      prefixCls: css(styles.tooltip(isWhiteDesign, layer, maxWidth)),
      trigger: trigger,
      placement: placement,
      overlay: getContent(),
      getTooltipContainer: isRelativeToChild ? node => node : undefined
    }, extraProps), renderChildren);
  });
};